module.exports = __webpack_public_path__ + "static/media/user-empty.89038852.svg";